module.exports = __webpack_public_path__ + "static/media/icon_star_outline.a933cbfb.svg";